import Axios from "axios";
import store from "@/store/index";
import { AuthService } from "./Auth";
import { Constantes } from "@/Util/Constantes";
import { Utilidades } from "@/Util/Utilidades";

export class BaseService {


    public static loadAxios(): void {


        Axios.interceptors.request.use(
            function (config) {
                let user = AuthService.getUsuario();
                let empresa = user?.id_empresa_seleccionado;
                let pagina = store.state.page;                
                let token = "";
                let cookie = "";      

                if (user) {
                    token = user.token;

                    cookie = Utilidades.getCookie(Constantes.SESSION_COOKIE);

                    if (!cookie) {
                        AuthService.logout();

                        return;
                    }
                }

                if (token) config.headers.Authorization = `Bearer ${token}`;
                else config.headers.Authorization = null;

                if (empresa) config.headers.empresa = empresa;

                if (pagina) config.headers.pagina = pagina;

                if (cookie) config.headers.session = cookie;

                // config.headers.Authorization = null;
                return config;
            },
            function (error) {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        Axios.interceptors.response.use(
            function (response) {
                // Any status code that lie within the range of 2xx cause this function to trigger
                // Do something with response data
     
                let ambiente = response.headers["ambiente"];
                let token = response.headers["token"];
                let version = response.headers["version"];
                let logout = response.headers["logout"];

                if (ambiente) {
                    store.commit("setAmbiente", ambiente);
                }

                if (version) {
                    store.commit("setVersion", version);

                    let user = AuthService.getUsuario();

                    if (user) {
                        if (user.version != version) {
                            AuthService.logout();
                            return;
                        }
                    }
                }

                if(logout){
                    Utilidades.sessionError(logout);
                }

                store.commit("setInactividad");

                if (token) {
                    if (token.split("#@#").length > 1) {
                        Utilidades.setCookie(Constantes.SESSION_COOKIE, token.split("#@#")[1], AuthService.getUsuario().session_timeout);
                        AuthService.updateToken(token.split("#@#")[0]);
                    } else {
                        AuthService.updateToken(token);
                    }
                }

                return response;
            },
            function (error) {
                let token = error.response.headers["token"];
                let logout = error.response.headers["logout"];

                if(logout){
                    Utilidades.sessionError(logout);
                }

                if (token) {
                    if (token.split("#@#").length > 1) {
                        Utilidades.setCookie(Constantes.SESSION_COOKIE, token.split("#@#")[1], AuthService.getUsuario().session_timeout);
                        AuthService.updateToken(token.split("#@#")[0]);
                    } else {
                        AuthService.updateToken(token);
                    }
                }
                // if (error.response.status == 401) AuthService.limparToken();
                // Any status codes that falls outside the range of 2xx cause this function to trigger
                // Do something with response error
                return Promise.reject(error);
            }
        );


        //console.log(Axios.defaults.baseURL)
        //console.log(store.state.API_ENDPOINT)


        // al entrar en la pagina viene vacio
        Axios.defaults.baseURL = store.state.API_ENDPOINT;

        if (!Axios.defaults.baseURL)
            Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        //console.log(Axios.defaults.baseURL)
        // if (Axios.defaults.baseURL == undefined || Axios.defaults.baseURL == null || Axios.defaults.baseURL == ''){
        //     Axios.defaults.baseURL = Constantes.URL_BASE_API;
        // }

        //Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    }

}
